import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import React from "react";
import "../Styles/_OrderOptions.css";

const OrderOptions = ({ order, currentLanguage, mobile, handleActionClick }) => {
    const boxStyle = mobile ? "order-menu-mobile" : "order-menu-desktop";
    const buttonStyle = mobile ? "order-menu-button-panel-item" : "order-menu-button";

    const renderButton = (action, label) => (
        <button onClick={() => handleActionClick(action, true)} className={`layout horizontal center justified allow-focus ${buttonStyle}`}>
            {label}
            <NavigateNextIcon />
        </button>
    );

    return (
        <div className={boxStyle}>
            {renderButton("REQUEST_ASSISTANCE", currentLanguage.ORDER_PAGE.MENU.REQUEST_ASSISTANCE)}
            {order.invoice_enabled && renderButton("INVOICE", currentLanguage.ORDER_PAGE.MENU.INVOICE)}

            {order.cancel_order_enabled &&
                (order.cancel_order_items_enabled
                    ? renderButton("CANCEL_ORDER_ITEMS", currentLanguage.ORDER_PAGE.MENU.CANCEL_ITEMS)
                    : renderButton("CANCEL_ORDER", currentLanguage.ORDER_PAGE.MENU.CANCEL_ORDER))}
            {order.return_order_enabled &&
                (order.return_order_items_enabled
                    ? renderButton("RETURN_ORDER_ITEMS", currentLanguage.ORDER_PAGE.MENU.RETURN_ITEMS)
                    : renderButton("RETURN_ORDER", currentLanguage.ORDER_PAGE.MENU.RETURN_ORDER))}
        </div>
    );
};

export default OrderOptions;
